<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <!-- No source handle: the enrollment has ended, so nothing can follow. -->
    <div class="workflow-node workflow-node--exit_allow_reentry">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">EXIT</div>
        <div class="workflow-node__title">Exit and Allow Re-entry</div>
        <div class="workflow-node__hint">Can enter this workflow again</div>
    </div>
</template>
